import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Collections, Parts, Types} from "components";
import UserRoles, {MANAGER_PLUS_ROLES} from "constants/UserRoles";
import {CirclePicker} from 'react-color'
import {Button, ButtonGroup, Input, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import moment from "moment"
import API from "@beardeddevops/react.api";
import ReactTable from "react-table";
import Edit from '@material-ui/icons/Edit'
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import WeekPickerSundayStart from "../Parts/WeekPickerSundayStart";
import APPCONFIG from "../../constants/Config";
import Download from "@material-ui/icons/GetApp";
import {confirmAlert} from "react-confirm-alert";

const colorOptions = [
	{color: "#9c27b0", name: "Purple"},
	{color: "#673ab7", name: "Deep Purple"},
	{color: "#3f51b5", name: "Indigo"},
	{color: "#2196f3", name: "Blue"},
	{color: "#03a9f4", name: "Light Blue"},
	{color: "#00bcd4", name: "Cyan"},
	{color: "#009688", name: "Teal"},
	{color: "#4caf50", name: "Green"},
	{color: "#8bc34a", name: "Light Green"},
	{color: "#cddc39", name: "Lime"},
	{color: "#ff9800", name: "Orange"},
	{color: "#ff5722", name: "Deep Orange"},
	{color: "#795548", name: "Brown"},
	{color: "#607d8b", name: "Blue Grey"}
];

const accountRegex = /^[0-9]*$/;
const routingRegex = /^[0-9]*$/;


/**
 *  @property {Users_Object} state
 *  @property {object} model
 *  @property {Users_Properties} model.properties
 *  @property {Users_Is} model.is
 *  @property {Users_Has} model.has
 */
class User extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Users._name);
		this.state.selfChange = props.roles.some(role => MANAGER_PLUS_ROLES.includes(role));
		this.update = this.state.selfChange ? 'POST' : 'POST_SELF';
		//if (!props.hasModal) this.redirect = '/users';
		//this.redirect = this.props.baseUrl;
		this.state.rolesLoaded = false;
		this.state.selectedDate = new Date(Date.now());
		this.state.selectedWeek = moment(Date.now()).isoWeek()
		this.state.tempWorkingDays = [];
		this.state.tempTimeOffData = [];
		this.state.all_roles = [];
		this.state.editModal = false
		this.state.toggleSchedule = false;
		this.state.toggleRegularSchedule = false;
		this.state.selectedSunday = null;
		this.state.accountChanged = false;
		this.state.routingChanged = false;
		this.state.dd_reviewing = false;
		this.state.password_bypass = this.props.rootState.user == this.state.pkey ? true : false;
	}

	/**
	 * @param prevProps
	 * @param {Users_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		const updates = {};
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
		if (prevState.roles.length !== this.state.roles.length) {
			if (this.state.roles.includes(1) && !this.props.roles.includes(UserRoles.Admin)) {
				this.setState({roles: prevState.roles})
			}
		}
		// Account number change
		if (this.state.dd_account) {
			if (prevState.dd_account !== this.state.dd_account && !this.state.dd_account.includes("*")) {
				updates.accountChanged = true;

				if (!this.state.dd_account) {
					updates.dd_account = "";
				} else if (!accountRegex.test(this.state.dd_account)) {
					updates.dd_account = prevState.dd_account;
				}
			}
		}

		// Routing number change
		if (prevState.dd_routing !== this.state.dd_routing) {
			if (this.state.dd_routing && !this.state.dd_routing.includes("*")) {
				updates.routingChanged = true;
			}
			if (!this.state.dd_routing) {
				updates.dd_routing = "";
			} else if (!routingRegex.test(this.state.dd_routing)) {
				updates.dd_routing = prevState.dd_routing;
			}
		}

		const nextDisabled = this.computeFormDisabled();
		if (this.state.formDisabled !== nextDisabled) {
			updates.formDisabled = nextDisabled;
		}

		// Apply all changes at once if needed
		if (Object.keys(updates).length > 0) {
			this.setState(updates);
		}
	}

	async componentDidMount() {
		super.componentDidMount();
		if (this.props.rootState.temp_password) {
			API.Toast.warn('You have to change your password!', {
				position: API.Toast.POSITION.TOP_RIGHT
			});
		}
		let all_roles = new API.BuildClass(Types.Roles._name, API.RequestType.READ_ALL)
		all_roles = await all_roles.submit(null, "GET_ALLOWED_ROLES");
		this.setState({all_roles: all_roles.items});
		await this.getTempDaysOff();
		if (this.props.rootState.user == this.state.pkey) {
			this.setState({selfChange: true})
			this.update = "POST_SELF";
		}
	}

	getTempDaysOff = async () => {
		let tempTimeModel = new API.BuildClass(Types.Temp_Days_Off._name, API.RequestType.READ);
		tempTimeModel.filter = {"filterEngineer": this.state.pkey}
		let tempTimeOffData = await tempTimeModel.submit(null, 'GET_ALL', true);
		tempTimeOffData = tempTimeOffData.items;
		this.setState({tempTimeOffData});
	}

	loadSelfBefore = async (data) => {
		let {onData} = this.props;

		if (typeof onData === 'function') onData(data);

		return data;
	}

	// noinspection JSUnusedGlobalSymbols
	/**
	 * @param {Users_Object} data
	 */
	loadSelfAfter(data) {
		this.lockedEmail = data.email;
		this.setState({
			roles: data.users_roless.map(item => item.role),
			rolesLoaded: true,
			onboarding_message: data.onboarding_message ?? null,
			dd_pending: this.isDdPending(data.dd_pending ?? data.Dd_Pending)
		})
	};

	async handleSubmit(event, suppressToast = false) {
		if (!this.state.main_role) {
			if (!this.state.pkey && this.state.roles.length === 0) {
				alert('Main Role is required, missing roles as well.')
				return;
			} else if (!this.state.pkey) {
				this.state.main_role = this.state.all_roles.find((role) => role.pkey === this.state.roles[0]).value
			} else {
				alert('Main Role is required.')
			}
		}
		let reload = false;
		if (this.state.password === '') {
			//faux setting the password on change since it is "required"
			this.state.password = 'AAAAAAAA';
			reload = true;
		}

		//if registering working days, was failing on non-FEs
		if (Array.isArray(this.state.workingDays)) {
			this.state.workingDays = this.state.workingDays.join(",");
		}

		// Office staff persist their regular schedule (day + time blocks) to the
		// schedules table; FEs use workingDays/tempDaysOff and don't need a template.
		const isOfficeRoleSubmit = this.state.roles.some(role => [2, 3, 6, 9, 10].includes(role));
		if (isOfficeRoleSubmit) {
			let schedule = this.state.schedule;
			if (typeof schedule === 'string') {
				try {
					schedule = JSON.parse(schedule || '[]');
				} catch (e) {
					schedule = [];
				}
			}
			if (!Array.isArray(schedule)) schedule = [];

			if (schedule.length === 0) {
				schedule = this.buildDefaultOfficeSchedule(this.state.workingDays);
			}

			const invalidDays = this.getRegularScheduleTimeRangeErrors(schedule);
			if (invalidDays.length > 0) {
				alert(`Start time must be before end time for: ${invalidDays.join(', ')}`);
				return;
			}

			this.state.schedule = JSON.stringify(schedule);
		} else {
			delete this.state.schedule;
		}

		if (!this.isAdmin() && this.lockedEmail != null) {
			this.state.email = this.lockedEmail;
		}

		const restoreDdFields = {};
		if (!this.state.accountChanged) {
			restoreDdFields.dd_account = this.state.dd_account;
			delete this.state.dd_account;
		}
		if (!this.state.routingChanged) {
			restoreDdFields.dd_routing = this.state.dd_routing;
			delete this.state.dd_routing;
		}

		await super.handleSubmit(event, suppressToast);

		if (restoreDdFields.dd_account !== undefined) {
			this.state.dd_account = restoreDdFields.dd_account;
		} else {
			this.state.accountChanged = false;
		}
		if (restoreDdFields.dd_routing !== undefined) {
			this.state.dd_routing = restoreDdFields.dd_routing;
		} else {
			this.state.routingChanged = false;
		}
		if (reload) {
			this.props.reloadPage();
		}
	}

	handleColor = (color) => {
		if (this.state.disabled) return;
		this.setState({eventColor: color.hex})
	}

	handleWorkingDays = (event) => {
		event.persist();
		let index = this.state.workingDays.indexOf(event.target.id)
		let _workingDays = this.state.workingDays;
		if (this.state.workingDays.includes(event.target.id)) {
			_workingDays.splice(index, 1)
			this.setState({workingDays: _workingDays})
		} else {
			_workingDays.push(event.target.id)
			this.setState({workingDays: _workingDays})
		}
	}


	/*Schedule stuff start*/

	to12Hour = (time24) => {
		let [h, m] = time24.split(':').map(Number);
		const suffix = h >= 12 ? 'PM' : 'AM';
		h = h % 12 || 12;
		return `${h}:${String(m).padStart(2, '0')}${suffix}`;
	};

	formatScheduleTimeLabel = (time24) => {
		let [h, m] = time24.split(':').map(Number);
		const suffix = h >= 12 ? 'PM' : 'AM';
		h = h % 12 || 12;
		return `${h}:${String(m).padStart(2, '0')} ${suffix}`;
	};

	to24Hour = (time12) => {
		const match = String(time12).match(/(\d+)(?::(\d+))?\s*(AM|PM)/i);
		if (!match) {
			return '09:00';
		}
		const [, h, m = '00', suffix] = match;
		let hour = parseInt(h, 10);
		if (suffix.toUpperCase() === 'PM' && hour !== 12) hour += 12;
		if (suffix.toUpperCase() === 'AM' && hour === 12) hour = 0;
		return `${hour.toString().padStart(2, '0')}:${m.padStart(2, '0')}`;
	};

	// Native time inputs ignore step in Chrome; use explicit 15-minute options.
	buildScheduleTimeOptions = () => {
		const options = [];
		for (let h = 0; h < 24; h++) {
			for (const m of [0, 15, 30, 45]) {
				const time24 = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
				options.push({ value: time24, label: this.formatScheduleTimeLabel(time24) });
			}
		}
		return options;
	};

	snapTime24ToQuarterHour = (time24) => {
		if (!time24 || !time24.includes(':')) {
			return '09:00';
		}
		let [h, m] = time24.split(':').map(Number);
		if (Number.isNaN(h) || Number.isNaN(m)) {
			return '09:00';
		}
		m = Math.round(m / 15) * 15;
		if (m === 60) {
			h += 1;
			m = 0;
		}
		if (h >= 24) {
			h = 0;
		}
		return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
	};

	scheduleTimeToMinutes = (time12) => {
		const time24 = this.to24Hour(time12);
		const [h, m] = time24.split(':').map(Number);
		return h * 60 + m;
	};

	isRegularBlockTimeRangeValid = (start12, end12) => {
		return this.scheduleTimeToMinutes(start12) < this.scheduleTimeToMinutes(end12);
	};

	getRegularScheduleTimeRangeErrors = (schedule = this.parseSchedule()) => {
		return schedule
			.filter((entry) => {
				const time = entry.times?.[0];
				if (typeof time !== 'string' || !time.includes('-')) {
					return true;
				}
				const [start12, end12] = time.split('-');
				return !this.isRegularBlockTimeRangeValid(start12, end12);
			})
			.map((entry) => entry.day);
	};

	renderScheduleTimeSelect = (time12, onChange) => {
		if (!this._scheduleTimeOptions) {
			this._scheduleTimeOptions = this.buildScheduleTimeOptions();
		}
		const time24 = this.snapTime24ToQuarterHour(this.to24Hour(time12));
		return (
			<Input
				type="select"
				bsSize="sm"
				className="schedule-time-select"
				style={{
					width: 132,
					display: 'inline-block',
					borderRadius: 6,
					borderColor: '#cbd5e1',
					backgroundColor: '#fff',
					fontSize: 14,
					padding: '4px 8px',
				}}
				value={time24}
				onChange={(e) => onChange(e.target.value)}
			>
				{this._scheduleTimeOptions.map((opt) => (
					<option key={opt.value} value={opt.value}>{opt.label}</option>
				))}
			</Input>
		);
	};


	handleDayToggle = (day) => {
		this.setState(prev => {
			const schedule = [...prev.schedule];
			const index = schedule.findIndex(d => d.day === day);

			// REMOVE
			if (index !== -1) {
				schedule.splice(index, 1);
				return {schedule};
			}

			// ADD (DEFAULT = 9AM-5PM)
			schedule.push({
				day,
				times: ['9AM-5PM']
			});

			return {schedule};
		});
	};


	handleTimeChange = (day, type, value, timeIndex = 0) => {
		this.setState(prev => {
			const schedule = [...prev.schedule];
			const dayIndex = schedule.findIndex(d => d.day === day);
			if (dayIndex === -1) return null;

			const times = [...(schedule[dayIndex].times || [])];

			// GUARANTEE an entry exists
			if (!times[timeIndex]) {
				times[timeIndex] = '9AM-5PM';
			}

			const current = times[timeIndex];

			// HARD NORMALIZATION (handles legacy 24h values safely)
			let start12 = '9AM';
			let end12 = '5PM';

			if (typeof current === 'string' && current.includes('-')) {
				const parts = current.split('-');
				start12 = parts[0] || start12;
				end12 = parts[1] || end12;
			}

			const start24 = this.snapTime24ToQuarterHour(this.to24Hour(start12));
			const end24 = this.snapTime24ToQuarterHour(this.to24Hour(end12));

			const newStart24 = type === 'start' ? this.snapTime24ToQuarterHour(value) : start24;
			const newEnd24 = type === 'end' ? this.snapTime24ToQuarterHour(value) : end24;

			times[timeIndex] =
				`${this.to12Hour(newStart24)}-${this.to12Hour(newEnd24)}`;

			schedule[dayIndex] = {
				...schedule[dayIndex],
				times
			};

			return {schedule};
		});
	};


	getDayEntry = (day) => {
		if (!this.state.schedule) return null;
		let schedule = this.state.schedule;
		if (typeof (schedule) === 'string') schedule = JSON.parse(schedule)
		return schedule.find(d => d.day === day)
	};

	/*Schedule stuff end*/


	handleTempWorkingDays = (event) => {
		let dayId = event.currentTarget.id;
		let _workingDays = [...this.state.tempWorkingDays]; // create shallow copy to avoid mutating state directly

		let index = _workingDays.indexOf(dayId);
		if (index !== -1) {
			_workingDays.splice(index, 1);
		} else {
			_workingDays.push(dayId);
		}

		this.setState({tempWorkingDays: _workingDays});
	}

	/*Office regular schedule (day + multiple time blocks) start*/

	parseSchedule = (schedule = this.state.schedule) => {
		if (!schedule) {
			return [];
		}
		if (typeof schedule === 'string') {
			try {
				schedule = JSON.parse(schedule || '[]');
			} catch (e) {
				return [];
			}
		}
		return Array.isArray(schedule) ? schedule : [];
	};

	// Matches the profile read-only fallback (workingDays + 9AM-5PM).
	buildDefaultOfficeSchedule = (workingDays = this.state.workingDays) => {
		const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		let off = workingDays;
		if (typeof off === 'string') {
			off = off.split(',').map((d) => d.trim()).filter(Boolean);
		} else if (Array.isArray(off)) {
			off = off.filter(Boolean);
		} else {
			off = [];
		}
		const effectiveOff = off.length > 0 ? off : ['Saturday', 'Sunday'];
		return days
			.filter((d) => !effectiveOff.includes(d))
			.map((d) => ({day: d, times: ['9AM-5PM']}));
	};

	openRegularScheduleEditor = () => {
		let schedule = this.parseSchedule();

		// Seed from the current recurring days off when no template exists yet.
		if (schedule.length === 0) {
			schedule = this.buildDefaultOfficeSchedule();
		}

		this.setState({
			toggleRegularSchedule: true,
			schedule,
			initialSchedule: JSON.parse(JSON.stringify(schedule)),
		});
	};

	handleRegularDayToggle = (day) => {
		this.setState(prev => {
			const schedule = [...this.parseSchedule(prev.schedule)];
			const index = schedule.findIndex(d => d.day === day);
			if (index !== -1) {
				schedule.splice(index, 1);
			} else {
				schedule.push({day, times: ['9AM-5PM']});
			}
			return {schedule};
		});
	};

	// Office staff have a single custom block per working day.
	handleRegularBlockTimeChange = (day, type, value) => {
		this.setState(prev => {
			const schedule = this.parseSchedule(prev.schedule).map(d => {
				if (d.day !== day) return d;
				const current = (typeof d.times?.[0] === 'string' && d.times[0].includes('-'))
					? d.times[0]
					: '9AM-5PM';
				const [start12 = '9AM', end12 = '5PM'] = current.split('-');
				const start24 = this.snapTime24ToQuarterHour(this.to24Hour(start12));
				const end24 = this.snapTime24ToQuarterHour(this.to24Hour(end12));
				const newStart24 = type === 'start' ? this.snapTime24ToQuarterHour(value) : start24;
				const newEnd24 = type === 'end' ? this.snapTime24ToQuarterHour(value) : end24;
				return {...d, times: [`${this.to12Hour(newStart24)}-${this.to12Hour(newEnd24)}`]};
			});
			return {schedule};
		});
	};

	handleRegularScheduleSave = () => {
		const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		const schedule = this.parseSchedule();
		const invalidDays = this.getRegularScheduleTimeRangeErrors(schedule);

		if (invalidDays.length > 0) {
			alert(`Start time must be before end time for: ${invalidDays.join(', ')}`);
			return;
		}

		const scheduledDays = schedule.map(d => d.day);
		// workingDays stores the recurring days OFF; keep it in sync with the template.
		const workingDays = days.filter(d => !scheduledDays.includes(d));

		this.setState({
			workingDays,
			toggleRegularSchedule: false,
			initialSchedule: null,
		});
	};

	handleRegularScheduleCancel = () => {
		this.setState({
			schedule: this.state.initialSchedule ?? [],
			toggleRegularSchedule: false,
			initialSchedule: null,
		});
	};

	/*Office regular schedule end*/


	handleTempTimeSave = async () => {
		if (this.state.selectedTime) {
			let tempTimeModel = new API.BuildClass(Types.Temp_Days_Off._name, API.RequestType.UPDATE);
			tempTimeModel.object = {...this.state.selectedTime}
			if (this.state.tempWorkingDays !== undefined || this.state.tempWorkingDays !== [] || this.state.tempWorkingDays !== null) {
				tempTimeModel.object.daysOff = this.state.tempWorkingDays.join(",");
			} else {
				tempTimeModel.object.daysOff = "";
			}
			await tempTimeModel.submit(null, 'POST').then(async () => {
				this.setState({tempWorkingDays: [], selectedTime: null, editModal: false})
				await this.getTempDaysOff();
			})
		} else {
			let tempTimeModel = new API.BuildClass(Types.Temp_Days_Off._name, API.RequestType.CREATE);
			tempTimeModel.object.engineer = this.state.pkey;
			const selectedYear = moment(this.state.selectedSunday).year();
			const selectedWeek = moment(this.state.selectedSunday).week();
			tempTimeModel.object.weekId = parseInt(`${selectedYear}${selectedWeek}`, 10);
			tempTimeModel.object.startDate = moment(this.state.selectedSunday).format('YYYY-MM-DD');
			if (this.state.tempWorkingDays !== undefined || this.state.tempWorkingDays !== [] || this.state.tempWorkingDays !== null) {
				tempTimeModel.object.daysOff = this.state.tempWorkingDays.join(",");
			} else {
				tempTimeModel.object.daysOff = "";
			}
			await tempTimeModel.submit(null, 'PUT').then(async () => {
				this.setState({tempWorkingDays: [], toggleCalendar: false})
				await this.getTempDaysOff();
			})
		}
	}

	passwordChange = (property, value) => {
		if (this.state.password_bypass) {
			this.handleTextFieldPropertyUpdate(property, value);
			return;
		}

		confirmAlert({
			title: 'Confirm Password Change',
			message: 'Are you sure you want to change this person\'s password?',
			buttons: [
				{
					label: 'Yes',
					color: 'danger',
					onClick: async () => {
						this.setState({password_bypass: true});
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	isManagerPlus = () => this.props.roles.some(role => MANAGER_PLUS_ROLES.includes(role));
	isAdmin = () => this.props.roles.includes(UserRoles.Admin);
	isViewingSelf = () => this.props.rootState.user == this.state.pkey;
	isFeTarget = () => this.state.roles.includes(4);
	isOfficeRole = () => this.state.roles.some(role => [2, 3, 6, 9, 10].includes(role));

	canReviewDd = () => this.props.roles.includes(UserRoles.Admin)
		|| this.props.roles.includes(UserRoles.Financial);

	isDdPending = (value = this.state.dd_pending) => value === true || value === 1 || value === '1';

	handleDismissDd = () => {
		if (!this.state.pkey || this.state.dd_reviewing) {
			return;
		}
		confirmAlert({
			title: 'Mark DD Info Reviewed',
			message: 'This will dismiss the pending direct deposit notification for this user. Continue?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						this.setState({dd_reviewing: true});
						try {
							const model = new API.BuildClass(Types.Users._name, API.RequestType.UPDATE);
							model.object.pkey = this.state.pkey;
							await model.submit(null, 'POST_DISMISS_DD');
							this.setState({dd_pending: false, dd_reviewing: false});
							if (this.props.rootState && typeof this.props.rootState.triggerAction === 'function') {
								this.props.rootState.triggerAction('handleSessionCheck');
							}
							API.Toast.success('Direct deposit info marked as reviewed.', {
								position: API.Toast.POSITION.TOP_RIGHT
							});
						} catch (e) {
							this.setState({dd_reviewing: false});
							API.Toast.error('Unable to dismiss the DD notification. Please try again.', {
								position: API.Toast.POSITION.TOP_RIGHT
							});
						}
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	computeFormDisabled = () => {
		let disabled = true;
		if (this.state.pkey === "") disabled = false;
		if (this.isAdmin()) disabled = false;
		else {
			if (this.isViewingSelf() && !this.isFeTarget()) disabled = false;
			// Manager+ (except Admin handled above) can edit non-Admin/Dev targets
			if (
				this.props.roles.some(role => [UserRoles.Executive, UserRoles.Manager, UserRoles.TORManager].includes(role))
				&& !(this.state.roles.includes(1) || this.state.roles.includes(2))
			) {
				disabled = false;
			}
			if (this.props.roles.length === 0 && this.state.pkey) disabled = false;
		}
		return disabled;
	};

	computeFinancialFlags = () => {
		let canSeeFinancials = false;
		let canEditFinancials = false;
		if (this.isViewingSelf()) {
			canSeeFinancials = true;
			canEditFinancials = true;
		}
		// Managers can view financials on other non-Admin/Dev profiles
		if (
			this.props.roles.some(role => [UserRoles.Manager, UserRoles.TORManager, UserRoles.Executive].includes(role))
			&& !this.isViewingSelf()
			&& !(this.state.roles.includes(1) || this.state.roles.includes(2))
		) {
			canSeeFinancials = true;
			canEditFinancials = false;
		}
		if (this.props.roles.includes(UserRoles.Admin)) {
			canSeeFinancials = true;
			canEditFinancials = true;
		} else if (this.props.roles.includes(UserRoles.Financial)) {
			canSeeFinancials = true;
			canEditFinancials = this.isViewingSelf();
		}
		return {canSeeFinancials, canEditFinancials};
	};

	/** Base pay + commission: Admin, Financial, Executive only (see = edit) */
	canSeePayFields = () => this.props.roles.some(role =>
		[UserRoles.Admin, UserRoles.Financial, UserRoles.Executive].includes(role)
	);

	isFieldDisabled = (field, baseDisabled) => {
		if (this.isAdmin()) return false; // Admin edits everything including email
		if (field === 'email') return true;
		if (['password', 'phone_cell', 'phone_home', 'phone_work'].includes(field) && this.isFeTarget()) return false;
		if (['dd_account', 'dd_routing'].includes(field)) {
			const {canEditFinancials} = this.computeFinancialFlags();
			return !canEditFinancials;
		}
		if (field === 'base_pay' || field === 'commission') {
			return !this.canSeePayFields();
		}
		if (field === 'workingDays' || field === 'regular_schedule') {
			return !this.isManagerPlus();
		}
		return baseDisabled;
	};

	isFieldHidden = (field) => {
		if (['onboarding_date', 'last_day_working'].includes(field)) {
			return !(this.isManagerPlus() && this.isFeTarget());
		}
		if (field === 'deep_sleep' || field === 'fill_hold') {
			return !(this.isAdmin() && this.isFeTarget());
		}
		if (field === 'base_pay' || field === 'commission') {
			return !this.canSeePayFields();
		}
		return false;
	};

	form = () => {
		/**
		 * @param {Users_Properties} data
		 */
		let {properties} = this.model
		/**
		 * @type {Users_Object} object
		 */
		let object = this.state
		let {loading, selfChange, accountChanged} = this.state

		if (this.isViewingSelf()) {
			selfChange = true;
		}

		const disabled = this.computeFormDisabled();
		const {canSeeFinancials} = this.computeFinancialFlags();
		const canEditRegularSchedule = this.isManagerPlus();
		const isOfficeRole = this.isOfficeRole();
		const showManagerial = this.isManagerPlus() || this.isViewingSelf();
		const parsedDaysOff = Array.isArray(this.state.workingDays)
			? this.state.workingDays.filter(Boolean)
			: [];
		const effectiveDaysOff = parsedDaysOff.length > 0
			? parsedDaysOff
			: (isOfficeRole ? ['Saturday', 'Sunday'] : []);
		const isProfileWorkingDay = (day) => !effectiveDaysOff.includes(day);

		// Office regular schedule = per-day time blocks (supports multiple blocks per day).
		const parsedSchedule = this.parseSchedule();
		const hasCustomSchedule = parsedSchedule.length > 0;
		const regularScheduleTimeErrors = this.getRegularScheduleTimeRangeErrors(parsedSchedule);
		// Returns the array of time blocks for a working day, or null if the day is off.
		const getDayTimes = (day) => {
			if (hasCustomSchedule) {
				const entry = parsedSchedule.find(d => d.day === day);
				return entry && Array.isArray(entry.times) && entry.times.length > 0 ? entry.times : null;
			}
			return isProfileWorkingDay(day) ? ['9AM-5PM'] : null;
		};

		this.state.disabled = disabled;
		const columns = [
			{
				Header: "Week Of",
				id: "daysFormatted",
				accessor: (obj) => {
					let start = null;
					let end = null;
					if (obj.startDate) {
						start = moment(obj.startDate).format('MMMM DD').toString();
						end = moment(obj.startDate).add(6, 'day').format('MMMM DD').toString();
						if (start.split(" ")[0] === end.split(" ")[0]) {
							end = end.split(" ")[1];
						}
					} else {
						start = moment(obj.weekId.toString().slice(0, 4) + "W" + obj.weekId.toString().slice(4, obj.weekId.toString().length)).format('MMMM DD').toString();
						end = moment(obj.weekId.toString().slice(0, 4) + "W" + obj.weekId.toString().slice(4, obj.weekId.toString().length)).add(6, 'day').format('MMMM DD').toString();
						if (start.split(" ")[0] === end.split(" ")[0]) {
							end = end.split(" ")[1];
						}
					}
					return start + "-" + end;
				}
			},
			{
				Header: "Days Off",
				id: "daysoff",
				accessor: (obj) => obj.daysOff
			},
			{
				Header: "Date Created",
				id: "created",
				accessor: obj => (moment(obj.created).local().format('MM/DD/YYYY h:mm A'))
			},
			{
				Header: "Creator",
				id: "creator",
				accessor: obj => obj.creator_name,
			},
			{
				Header: "modifier",
				id: "modifier",
				accessor: obj => (obj.modifier_name ? obj.modifier_name : "N/A")
			},
			{
				Header: "Modified",
				id: "datemodified",
				accessor: obj => (obj.modified ? moment(obj.modified).local().format('MM/DD/YYYY h:mm A') : "N/A")
			},
			{
				Header: "",
				id: "edit",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				accessor: obj => obj.name,
				Cell: props => {
					return (
						<Button color="green-meadow" size={"sm"} block={true} onClick={() => {
							this.setState({editModal: true, selectedTime: props.original, tempWorkingDays: props.original.daysOff.split(',')})
						}} disabled={disabled}>
							<Edit fontSize={'small'}/></Button>
					)
				}
			}
		];

		if (!this.state.workingDays) {
			this.state.workingDays = [];
		} else if (typeof this.state.workingDays === 'string') {
			this.setState({workingDays: this.state.workingDays.split(",")})
		}
		if (!this.state.schedule) {
			this.state.schedule = [];
		} else if (typeof this.state.schedule === 'string') {
			this.setState({schedule: JSON.parse(this.state.schedule)})
		}

		const eventColorDisabled = this.isFieldDisabled('eventColor', disabled);

		return (
			<div>
				{(this.state.rolesLoaded || this.state.pkey === "") &&
					<fieldset>
						{object.onboarding_message && <b>{object.onboarding_message}</b>}
						{this.state.onboarding_message?.includes('mobile app') &&
							<a href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/accounts/downloadapp`}>
								<Button
									color="primary"
									style={{
										display: "flex",
										alignItems: "center",
										gap: "0.5rem",
										textDecoration: "none",
										width: "12rem"
									}}
								>
									<Download size={18}/>
									<span>Download App</span>
								</Button>
							</a>}

						<>
							{(() => {
								const cardStyle = {marginBottom: 0, height: '100%'};
								const cardPad = {paddingTop: '10px', paddingBottom: 0};
								const showScheduleCard = showManagerial && (
									this.isFeTarget()
									|| (isOfficeRole && (selfChange || this.isManagerPlus()))
								);
								const showAdminCard = showManagerial || canSeeFinancials;
								const mainRoleObjects = (object.users_roless || object.roles)
									? (object.pkey
										? (object.users_roless || []).map((item) => object.all_roles.find((role) => role.pkey === item.role)).filter(Boolean)
										: (object.roles || []).map((item) => object.all_roles.find((role) => role.pkey === item)).filter(Boolean))
									: [];
								const showFirstLast = !this.isFieldHidden('onboarding_date') || !this.isFieldHidden('last_day_working');

								return (
									<>
										{/* Row 1: Contact + Address */}
										<div className="row">
											<div className="col-lg-6 col-md-12" style={{marginBottom: 8}}>
												<Card style={cardStyle} variant="outlined">
													<CardContent style={cardPad}>
														<h4 className="section-title">Contact</h4>
														<div className="row">
															<div className="col-sm-6">
																<div className="form-group">
																	<Framework.Elements.TextField
																		property={properties.name_first}
																		value={object.name_first}
																		error={object.name_first_error}
																		update={this.handleTextFieldPropertyUpdate}
																		label={'First Name'}
																		disabled={this.isFieldDisabled('name_first', disabled)}
																	/>
																</div>
															</div>
															<div className="col-sm-6">
																<div className="form-group">
																	<Framework.Elements.TextField
																		property={properties.name_last}
																		value={object.name_last}
																		error={object.name_last_error}
																		update={this.handleTextFieldPropertyUpdate}
																		label={'Last Name'}
																		disabled={this.isFieldDisabled('name_last', disabled)}
																	/>
																</div>
															</div>
															<div className="col-sm-6">
																<div className="form-group">
																	{this.isAdmin() ? (
																		<Framework.Elements.EmailAddress
																			property={properties.email}
																			value={object.email}
																			error={object.email_error}
																			update={this.handleTextFieldPropertyUpdate}
																			label={'Email Address'}
																			type={'email'}
																		/>
																	) : (
																		<TextField
																			label="Email Address"
																			value={object.email || ''}
																			variant="outlined"
																			margin="dense"
																			fullWidth
																			InputProps={{readOnly: true}}
																			inputProps={{tabIndex: -1, autoComplete: 'off'}}
																		/>
																	)}
																</div>
															</div>
															<div className="col-sm-6">
																<div className="form-group">
																	<Framework.Elements.TextField
																		property={properties.password}
																		value={object.password}
																		error={object.password_error}
																		update={(property, value) => this.passwordChange(property, value)}
																		label={'Password'}
																		type={'password'}
																		disabled={this.isFieldDisabled('password', disabled)}
																	/>
																</div>
															</div>
															<div className="col-sm-4">
																<div className="form-group">
																	<Framework.Elements.PhoneNumber
																		property={properties.phone_cell}
																		value={object.phone_cell}
																		error={object.phone_cell_error}
																		update={this.handleTextFieldPropertyUpdate}
																		label={'Cell Phone'}
																		disabled={this.isFieldDisabled('phone_cell', disabled)}
																	/>
																</div>
															</div>
															<div className="col-sm-4">
																<div className="form-group">
																	<Framework.Elements.PhoneNumber
																		property={properties.phone_home}
																		value={object.phone_home}
																		error={object.phone_home_error}
																		update={this.handleTextFieldPropertyUpdate}
																		label={'Home Phone'}
																		disabled={this.isFieldDisabled('phone_home', disabled)}
																	/>
																</div>
															</div>
															<div className="col-sm-4">
																<div className="form-group">
																	<Framework.Elements.PhoneNumber
																		property={properties.phone_work}
																		value={object.phone_work}
																		error={object.phone_work_error}
																		update={this.handleTextFieldPropertyUpdate}
																		label={'Work Phone'}
																		disabled={this.isFieldDisabled('phone_work', disabled)}
																	/>
																</div>
															</div>
														</div>
													</CardContent>
												</Card>
											</div>
											<div className="col-lg-6 col-md-12" style={{marginBottom: 8}}>
												<Card style={cardStyle} variant="outlined">
													<CardContent style={cardPad}>
														<h4 className="section-title">Address</h4>
														<Parts.Address
															object={{...this.state}}
															properties={properties}
															parent={this}
															disabled={this.isFieldDisabled('address', disabled)}
														/>
													</CardContent>
												</Card>
											</div>
										</div>

										{/* Row 2: Administrative + Days Off */}
										{(showAdminCard || showScheduleCard) &&
											<div className="row">
												{showAdminCard &&
												<div className={showScheduleCard ? 'col-lg-6 col-md-12' : 'col-12'} style={{marginBottom: 8}}>
													<Card style={cardStyle} variant="outlined">
														<CardContent style={cardPad}>
															{showManagerial &&
															<>
															<div className="section-title" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
																<h4 className="section-title" style={{margin: 0}}>Administrative</h4>
																{this.isFeTarget() && this.state.service_latitude != 0 && this.state.service_latitude && this.state.service_longitude != 0 && this.state.service_longitude &&
																	<a href={`https://www.google.com/maps/dir/${this.state.service_latitude}, ${this.state.service_longitude}`}
																	   target={"_blank"}>
																		<Button color="info" size="sm">
																			View Center
																		</Button>
																	</a>}
															</div>
															<div className="row">
																<div className={mainRoleObjects.length ? 'col-sm-5' : 'col-sm-8'} style={{ zIndex: 999}}>
																	<div className="form-group">
																		<Framework.Elements.Select
																			disabled={this.isFieldDisabled('roles', disabled)}
																			shouldLoad={this.state.loaded}
																			property={properties.roles}
																			values={object.roles}
																			error={object.roles_error}
																			model={Types.Roles._name}
																			requestOverride={"GET_ALLOWED_ROLES"}
																			update={this.handleSelectPropertyUpdate}
																			label={"Roles"}
																			nullable={!!!object.pkey}
																			limit={null}
																			isMulti
																			styles={{
																				control: (provided) => ({
																					...provided,
																					minHeight: '30px',
																				}),
																				valueContainer: (provided) => ({
																					...provided,
																					overflow: 'visible',
																					padding: '1px 8px',
																				}),
																				multiValue: (provided) => ({
																					...provided,
																					zIndex: 2,
																				}),
																				placeholder: (provided, state) => {
																					const floated = state.hasValue || !!state.selectProps.inputValue;
																					return {
																						...provided,
																						position: 'absolute',
																						top: -4,
																						left: -4,
																						marginLeft: 0,
																						marginRight: 0,
																						fontSize: '1rem',
																						color: floated ? 'rgba(0, 0, 0, 0.54)' : provided.color,
																						transition: 'top 200ms, margin-left 200ms, background-color 200ms, font-size 200ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
																						transform: floated ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 10px) scale(1)',
																						transformOrigin: 'top left',
																						backgroundColor: floated ? 'white' : undefined,
																						padding: floated ? '0 8px' : undefined,
																						zIndex: 1,
																					};
																				},
																			}}
																		/>
																	</div>
																</div>
																{mainRoleObjects.length > 0 &&
																	<div className="col-sm-3">
																		<div className="form-group">
																			<Framework.Elements.Select
																				shouldLoad={this.state.loaded}
																				property={properties.main_role}
																				value={object.main_role}
																				error={object.main_role_error || ''}
																				objects={mainRoleObjects}
																				id="value"
																				text="name"
																				update={this.handleSelectPropertyUpdate}
																				label="Main Role"
																				nullable={false}
																				disabled={this.isFieldDisabled('main_role', disabled)}
																				limit={null}
																			/>
																		</div>
																	</div>}
																<div className="col-sm-4">
																	<div className="form-group">
																		<Framework.Elements.Select
																			shouldLoad={this.state.loaded}
																			property={properties.region}
																			value={object.region}
																			error={object.region_error}
																			object={object.regions}
																			update={this.handleSelectPropertyUpdate}
																			nullable={true}
																			disabled={this.isFieldDisabled('region', disabled)}
																			label={'Service Region'}
																		/>
																	</div>
																</div>
															</div>

															{this.isFeTarget() &&
																<>
																	<div className="row">
																		<div className="col-sm-3">
																			<div className="form-group">
																				<Framework.Elements.TextField
																					property={properties.service_radius}
																					value={object.service_radius}
																					error={object.service_radius_error}
																					update={this.handleTextFieldPropertyUpdate}
																					label={'Service Radius'}
																					disabled={this.isFieldDisabled('service_radius', disabled)}
																				/>
																			</div>
																		</div>
																		<div className="col-sm-3">
																			<div className="form-group">
																				<Framework.Elements.TextField
																					property={properties.service_latitude}
																					value={object.service_latitude}
																					error={object.service_latitude_error}
																					update={this.handleTextFieldPropertyUpdate}
																					label={'Center Latitude'}
																					disabled={this.isFieldDisabled('service_latitude', disabled)}
																				/>
																			</div>
																		</div>
																		<div className="col-sm-3">
																			<div className="form-group">
																				<Framework.Elements.TextField
																					property={properties.service_longitude}
																					value={object.service_longitude}
																					error={object.service_longitude_error}
																					update={this.handleTextFieldPropertyUpdate}
																					label={'Center Longitude'}
																					disabled={this.isFieldDisabled('service_longitude', disabled)}
																				/>
																			</div>
																		</div>
																		<div className="col-sm-3">
																			<div className="form-group">
																				<Framework.Elements.TextField
																					property={properties.fe_work_order_amount}
																					value={object.fe_work_order_amount}
																					error={object.fe_work_order_amount_error}
																					update={this.handleTextFieldPropertyUpdate}
																					label={'WO Amount (Expected)'}
																					disabled={this.isFieldDisabled('fe_work_order_amount', disabled)}
																				/>
																			</div>
																		</div>
																	</div>
																	<div className="row">
																		{!this.isFieldHidden('deep_sleep') &&
																			<div className="col-sm-4">
																				<div className="form-group" style={{
																					display: 'flex',
																					alignItems: 'center',
																					justifyContent: 'space-between',
																					gap: 8,
																					minHeight: 40,
																				}}>
																					<span style={{whiteSpace: 'nowrap', fontWeight: 500}}>Deep Sleep</span>
																					<Framework.Elements.ButtonSwitch
																						value={object.deep_sleep}
																						error={object.deep_sleep_error}
																						property={properties.deep_sleep}
																						update={this.handleTextFieldPropertyUpdate}
																						labelTrue={"Yes"}
																						labelFalse={"No"}
																					/>
																				</div>
																			</div>}
																		{!this.isFieldHidden('fill_hold') && properties.fill_hold &&
																			<div className="col-sm-4">
																				<div className="form-group" style={{
																					display: 'flex',
																					alignItems: 'center',
																					justifyContent: 'space-between',
																					gap: 8,
																					minHeight: 40,
																				}}>
																					<Tooltip
																						title="Hidden from booking until all non-secondary bookable engineers in this metro are out of openings."
																						arrow
																					>
																						<span style={{whiteSpace: 'nowrap', fontWeight: 500, cursor: 'help'}}>Secondary FE</span>
																					</Tooltip>
																					<Framework.Elements.ButtonSwitch
																						value={object.fill_hold}
																						error={object.fill_hold_error}
																						property={properties.fill_hold}
																						update={this.handleTextFieldPropertyUpdate}
																						labelTrue={"Yes"}
																						labelFalse={"No"}
																					/>
																				</div>
																			</div>}
																		{this.state.roles.length > 1 &&
																			<div className="col-sm-4">
																				<div className="form-group" style={{
																					display: 'flex',
																					alignItems: 'center',
																					justifyContent: 'space-between',
																					gap: 8,
																					minHeight: 40,
																				}}>
																					<span style={{whiteSpace: 'nowrap', fontWeight: 500}}>Show On Calendar</span>
																					<Framework.Elements.ButtonSwitch
																						value={object.calendarException}
																						error={object.calendarException_error}
																						property={properties.calendarException}
																						update={this.handleTextFieldPropertyUpdate}
																						labelTrue={"Yes"}
																						labelFalse={"No"}
																						disabled={this.isFieldDisabled('calendarException', disabled)}
																					/>
																				</div>
																			</div>}
																	</div>
																</>}

															{(showFirstLast || this.isFeTarget()) &&
																<div className="row" style={{marginTop: 4}}>
																	{showFirstLast &&
																		<div className="col-6">
																			{!this.isFieldHidden('onboarding_date') &&
																				<div className="form-group">
																					<Framework.Elements.Date
																						label="First Day in Field"
																						property={properties.onboarding_date}
																						value={moment.parseZone(object.onboarding_date).format("MM/DD/YYYY")}
																						error={object.onboarding_date_error}
																						update={this.handleTextFieldPropertyUpdate}
																						disabled={this.isFieldDisabled('onboarding_date', disabled)}
																					/>
																				</div>}
																			{!this.isFieldHidden('last_day_working') &&
																				<div className="form-group">
																					<Framework.Elements.Date
																						label="Last Day Working"
																						property={properties.last_day_working}
																						value={object.last_day_working ? moment.parseZone(object.last_day_working).format("MM/DD/YYYY") : ""}
																						error={object.last_day_working_error}
																						update={this.handleTextFieldPropertyUpdate}
																						disabled={this.isFieldDisabled('last_day_working', disabled)}
																					/>
																				</div>}
																		</div>}
																	{this.isFeTarget() &&
																		<div className={showFirstLast ? 'col-6' : 'col-12'}>
																			<h4 className="section-title" style={{fontSize: '0.95rem', marginBottom: 6}}>Event Color</h4>
																			<div className="form-group">
																				<div style={{display: "flex", flexWrap: "wrap", width: "100%"}}>
																					{colorOptions.map((option) => (
																						<div
																							key={option.color}
																							title={option.name}
																							onClick={() => {
																								if (!eventColorDisabled) this.handleColor({hex: option.color});
																							}}
																							style={{
																								backgroundColor: option.color,
																								width: 20,
																								height: 20,
																								borderRadius: "50%",
																								margin: 2,
																								cursor: eventColorDisabled ? "default" : "pointer",
																								opacity: eventColorDisabled ? 0.6 : 1,
																								border: this.state.eventColor === option.color ? "2px solid black" : "1px solid #ccc"
																							}}
																						/>
																					))}
																				</div>
																				<div style={{
																					color: this.state.eventColor,
																					fontWeight: "bold",
																					fontSize: '0.8rem',
																					marginTop: 2,
																					borderTop: `3px solid ${this.state.eventColor}`,
																					paddingTop: 2,
																				}}>
																					{colorOptions.find(c => c.color === this.state.eventColor)?.name || "Select a color"}
																				</div>
																			</div>
																		</div>}
																</div>}
															</>}

															{canSeeFinancials &&
																<>
																	<h4 className="section-title" style={{marginTop: showManagerial ? 12 : 0}}>Financial</h4>
																	<div className="row">
																		<div className="col-sm-6">
																			<div className="form-group">
																				<Framework.Elements.TextField
																					property={properties.dd_account}
																					value={object.dd_account}
																					error={object.dd_account_error}
																					update={this.handleTextFieldPropertyUpdate}
																					label={'Account Number'}
																					disabled={this.isFieldDisabled('dd_account', disabled)}
																				/>
																			</div>
																		</div>
																		<div className="col-sm-6">
																			<div className="form-group">
																				<Framework.Elements.TextField
																					property={properties.dd_routing}
																					value={object.dd_routing}
																					error={object.dd_routing_error}
																					update={this.handleTextFieldPropertyUpdate}
																					label={'Routing Number'}
																					disabled={this.isFieldDisabled('dd_routing', disabled)}
																				/>
																			</div>
																		</div>
																		{!this.isFieldHidden('base_pay') &&
																		<div className="col-sm-6">
																			<div className="form-group">
																				<Framework.Elements.TextField
																					property={properties.base_pay}
																					value={object.base_pay}
																					error={object.base_pay_error}
																					update={this.handleTextFieldPropertyUpdate}
																					label={'Base Pay'}
																					disabled={this.isFieldDisabled('base_pay', disabled)}
																				/>
																			</div>
																		</div>}
																		{this.isFeTarget() && !this.isFieldHidden('commission') &&
																			<div className="col-sm-6">
																				<div className="form-group">
																					<Framework.Elements.TextField
																						property={properties.commission}
																						value={object.commission}
																						error={object.commission_error}
																						update={this.handleTextFieldPropertyUpdate}
																						label={'Commission'}
																						disabled={this.isFieldDisabled('commission', disabled)}
																					/>
																				</div>
																			</div>}
																		{this.canReviewDd() && this.isDdPending() &&
																			<div className="col-sm-12">
																				<div className="form-group" style={{marginTop: 8}}>
																					<p style={{marginBottom: 8, fontWeight: 500}}>
																						Direct deposit info was updated and is waiting for review.
																					</p>
																					<Button
																						type="button"
																						color="success"
																						size="sm"
																						disabled={this.state.dd_reviewing}
																						onClick={this.handleDismissDd}
																					>
																						{this.state.dd_reviewing ? 'Saving...' : 'Mark DD Reviewed'}
																					</Button>
																				</div>
																			</div>}
																	</div>
																</>}
														</CardContent>
													</Card>
												</div>}

												{showScheduleCard &&
													<div className="col-lg-6 col-md-12" style={{marginBottom: 8}}>
														<Card style={cardStyle} variant="outlined">
															<CardContent style={cardPad}>
																{this.isFeTarget() &&
																	<>
																		<div className="section-title" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
																			<h4 className="section-title" style={{margin: 0}}>Days Off (Expected)</h4>
																			{canEditRegularSchedule &&
																				<Button color="info" size="sm" onClick={() => {
																					this.setState({toggleCalendar: true})
																				}}>
																					Swap Days Off
																				</Button>}
																		</div>
																		<div className="form-group">
																			<ButtonGroup size="md" className="w-100 flex-nowrap">
																				{['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day) => {
																					return (
																						<Button
																							key={day}
																							id={day}
																							onClick={this.handleWorkingDays}
																							outline={!this.state.workingDays.includes(day)}
																							active={this.state.workingDays.includes(day)}
																							color={"primary"}
																							disabled={this.isFieldDisabled('workingDays', disabled)}
																							style={{
																								flex: '1 1 0',
																								minWidth: 0,
																							}}
																						>
																							{day}
																						</Button>
																					);
																				})}
																			</ButtonGroup>
																		</div>
																	</>}

																{isOfficeRole && (selfChange || this.isManagerPlus()) &&
																	<>
																		<div className="section-title" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
																			<h4 className="section-title" style={{margin: 0}}>Regular Schedule</h4>
																			{!this.isFieldDisabled('regular_schedule', disabled) &&
																				<div style={{display: 'flex', gap: 6}}>
																					<Button color="info" size="sm" onClick={() => {
																						this.setState({toggleCalendar: true})
																					}}>
																						Swap Days Off
																					</Button>
																					<Button color="info" size="sm" onClick={this.openRegularScheduleEditor}>
																						Edit Regular Schedule
																					</Button>
																				</div>}
																		</div>
																		<div className="form-group">
																			<ButtonGroup size="md" className="w-100 flex-nowrap">
																				{['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(day => {
																					const times = getDayTimes(day);
																					const isWorking = !!times;
																					return (
																						<Button
																							key={day}
																							outline={!isWorking}
																							active={isWorking}
																							color="primary"
																							disabled
																							style={{
																								flex: '1 1 0',
																								minWidth: 0,
																								padding: '0.3rem 0.2rem',
																							}}
																						>
																							<div style={{
																								display: 'flex',
																								flexDirection: 'column',
																								fontSize: 'clamp(10px, 1.1vw, 13px)',
																								lineHeight: 1.15,
																								whiteSpace: 'nowrap',
																								overflow: 'hidden',
																							}}>
																								<div>{day}</div>
																								{isWorking
																									? times.map((t, i) => <div key={i}>{t}</div>)
																									: <div>Off</div>}
																							</div>
																						</Button>
																					);
																				})}
																			</ButtonGroup>
																		</div>
																	</>}

																{this.state.tempTimeOffData.length > 0 &&
																	<ReactTable
																		columns={columns}
																		manual
																		data={this.state.tempTimeOffData}
																		loading={loading}
																		loadingText={'Requesting Data'}
																		expanderDefaults={{
																			sortable: false,
																			resizable: false,
																			filterable: false,
																			width: undefined
																		}}
																		className='-striped -highlight'
																		defaultPageSize={this.state.tempTimeOffData.length}
																		showPagination={false}
																	/>
																}
															</CardContent>
														</Card>
													</div>}
											</div>}
									</>
								);
							})()}
						</>
					</fieldset>}
				<Modal
					isOpen={this.state.toggleCalendar}
					toggle={() => {
						this.setState({toggleCalendar: false})
					}}
					size={"lg"}
					backdrop={true}
					style={{opacity: 1}}
				>
					<ModalHeader>
						Swap Days Off
					</ModalHeader>
					<ModalBody>
						<p style={{marginBottom: 16, color: '#555'}}>
							{isOfficeRole
								? 'Pick a week, then select the days this user will be off that week only. Highlighted days are days off; unhighlighted days are working days. This overrides their regular schedule for that week (for example, working a normally-off Saturday).'
								: 'Pick a week, then select the days this user will be off that week only. Highlighted days are days off; unhighlighted days are working days.'}
						</p>
						<div className="form-group" style={{marginBottom: 20}}>
							<label style={{
								display: 'block',
								fontWeight: 600,
								marginBottom: 6,
							}}>
								Week of
							</label>
							<p style={{fontSize: '0.85rem', color: '#777', marginBottom: 8}}>
								Choose any date in the week - it will snap to that Sunday.
							</p>
							<WeekPickerSundayStart setSelectedSunday={(sunday) => {
								this.setState({selectedSunday: sunday})
							}}/>
						</div>
						{this.state.selectedSunday &&
							<div className="form-group" key={this.state.tempWorkingDays?.length + '_id'}>
								<label style={{
									display: 'block',
									fontWeight: 600,
									marginBottom: 6,
								}}>
									Days off this week
								</label>
								<p style={{fontSize: '0.85rem', color: '#777', marginBottom: 10}}>
									Click a day to mark it as off (blue) or working (outlined).
								</p>
								<ButtonGroup size="md" className="w-100 flex-nowrap">
									{['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day, index) => {
										const isOff = this.state.tempWorkingDays.includes(day);
										return (
											<Button
												key={day}
												id={day}
												onClick={this.handleTempWorkingDays}
												outline={!isOff}
												active={isOff}
												color="primary"
												style={{
													flex: '1 1 0',
													minWidth: 0,
													display: 'flex',
													flexDirection: 'column',
													justifyContent: 'center',
													alignItems: 'center',
													padding: '12px 6px',
													lineHeight: 1.25,
												}}
											>
												<div style={{fontWeight: 600}}>{day}</div>
												<div style={{
													fontSize: '0.85em',
													opacity: 0.9,
													color: isOff ? 'inherit' : '#555',
												}}>
													{moment(this.state.selectedSunday).add(index, 'days').format('MMM D')}
												</div>
												<div style={{
													fontSize: '0.75em',
													marginTop: 2,
													fontWeight: 500,
													opacity: 0.85,
												}}>
													{isOff ? 'Off' : 'Working'}
												</div>
											</Button>
										);
									})}
								</ButtonGroup>
							</div>}
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.handleTempTimeSave}>Save</Button>
						<Button color="secondary" onClick={() => {
							this.setState({toggleCalendar: false, selectedSunday: null, tempWorkingDays: []})
						}}>Close</Button>
					</ModalFooter>
				</Modal>

				<Modal
					isOpen={this.state.toggleRegularSchedule}
					toggle={this.handleRegularScheduleCancel}
					size={"lg"}
					backdrop={true}
					style={{opacity: 1}}
				>
					<ModalHeader>
						Edit Regular Schedule
					</ModalHeader>
					<ModalBody>
						<p>Toggle the days this user regularly works, then set their working hours for each
							day (one block per day). Days left off are treated as regular days off.</p>
						<div className="form-group">
							{['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day) => {
								const entry = parsedSchedule.find(d => d.day === day);
								const isWorking = !!entry;
								const time = (isWorking && typeof entry.times?.[0] === 'string') ? entry.times[0] : '9AM-5PM';
								const [start12 = '9AM', end12 = '5PM'] = time.split('-');
								const hasInvalidTimeRange = isWorking
									&& !this.isRegularBlockTimeRangeValid(start12, end12);

								return (
									<div key={day} style={{
										display: 'flex',
										alignItems: 'center',
										gap: 16,
										padding: '8px 0',
										borderBottom: '1px solid #eee',
									}}>
										<Button
											onClick={() => this.handleRegularDayToggle(day)}
											outline={!isWorking}
											active={isWorking}
											color="primary"
											style={{minWidth: 120}}
										>
											{day}
										</Button>

										{isWorking ? (
											<div style={{flex: 1}}>
												<div style={{display: 'flex', alignItems: 'center', gap: 10}}>
													<div>
														<b style={{marginRight: 5}}>Start</b>
														{this.renderScheduleTimeSelect(start12, (value) =>
															this.handleRegularBlockTimeChange(day, 'start', value)
														)}
													</div>
													<div>
														<b style={{marginRight: 5}}>End</b>
														{this.renderScheduleTimeSelect(end12, (value) =>
															this.handleRegularBlockTimeChange(day, 'end', value)
														)}
													</div>
												</div>
												{hasInvalidTimeRange && (
													<div style={{color: '#c0392b', fontSize: 13, marginTop: 4}}>
														Start time must be before end time.
													</div>
												)}
											</div>
										) : (
											<div style={{color: '#888'}}>Off</div>
										)}
									</div>
								);
							})}
						</div>
					</ModalBody>
					<ModalFooter>
						<Button
							color="primary"
							disabled={regularScheduleTimeErrors.length > 0}
							onClick={this.handleRegularScheduleSave}
						>
							Save
						</Button>
						<Button color="secondary" onClick={this.handleRegularScheduleCancel}>Close</Button>
					</ModalFooter>
				</Modal>

				<Modal
					isOpen={this.state.toggleSchedule}
					toggle={() => {
						this.setState({toggleSchedule: false})
					}}
					size={"lg"}
					backdrop={true}
					style={{opacity: 1}}
				>
					<ModalHeader>
						Set Dispatcher Schedule
					</ModalHeader>
					<ModalBody>
						<div className="form-group">
							<div className={'row'}>
								<ButtonGroup size="md" vertical>
									{['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(day => {
										const entry = this.getDayEntry(day);
										const time = entry?.times?.[0] ?? '9AM-5PM';
										const [start12 = '9AM', end12 = '5PM'] = time.split('-');

										console.log('STARTS', start12, end12)
										return (
											<div key={day} style={{display: 'flex'}}>
												<Button
													onClick={() => this.handleDayToggle(day)}
													outline={!entry}
													active={!!entry}
													color="primary"
												>
													{day}
												</Button>

												{entry && (
													<div style={{display: 'flex', paddingLeft: 10}}>
														<div style={{marginRight: 20}}>
															<b>Start</b>
															{this.renderScheduleTimeSelect(start12, (value) =>
																this.handleTimeChange(day, 'start', value)
															)}
														</div>

														<div>
															<b>End</b>
															{this.renderScheduleTimeSelect(end12, (value) =>
																this.handleTimeChange(day, 'end', value)
															)}
														</div>
													</div>
												)}
											</div>
										);
									})}
								</ButtonGroup>

							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={() => {
							this.setState({toggleSchedule: false})
						}}>Save</Button>
						<Button color="secondary" onClick={() => {
							this.setState({
								toggleSchedule: false,
								schedule: this.state.initialSchedule,
								initialSchedule: null,
							})
						}}>Close</Button>
					</ModalFooter>
				</Modal>

				<Modal
					isOpen={this.state.editModal}
					toggle={() => {
						this.setState({editModal: false, selectedTime: null})
					}}
					size={"lg"}
					backdrop={true}
					style={{opacity: 1}}
				>
					<ModalHeader>
						Edit Days Off
					</ModalHeader>
					<ModalBody>
						{this.state.selectedTime?.startDate ? <div className="form-group">
							<div className={'row'}>
								<WeekPickerSundayStart defaultDate={this.state.selectedTime.startDate} setSelectedSunday={(sunday) => {
									this.setState({selectedTime: {...this.state.selectedTime, startDate: sunday}})
								}}/>
							</div>
							<br/>
							{this.state.selectedTime?.startDate && <div className={'row'} key={this.state.tempWorkingDays?.length + '_id'}>
								<ButtonGroup size={"md"}>
									{['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day, index) => {
										return <div key={day} style={{display: 'flex', flexDirection: 'row'}}>
											<Button
												id={day}
												onClick={this.handleTempWorkingDays}
												outline={!this.state.tempWorkingDays.includes(day)}
												active={this.state.tempWorkingDays.includes(day)}
												color="primary"
												style={{
													display: 'flex',
													flexDirection: 'column',
													justifyContent: 'center',
													alignItems: 'center',
													padding: '10px 12px',
													borderRadius: '8px',
													minWidth: '80px',
													lineHeight: 1.2,
												}}
											>
												<div style={{fontWeight: '500'}}>{day}</div>
												<div style={{fontSize: '0.9em', color: this.state.tempWorkingDays.includes(day) ? 'white' : '#333'}}>
													{moment(this.state.selectedTime?.startDate).add(index, 'days').format('MMM D')}
												</div>
											</Button>
										</div>
									})}
								</ButtonGroup>
							</div>}
						</div> : <div className="form-group">
							<div className={'row'}>
								<input id="week" type="week" name="week" disabled={true}
								       value={this.state.selectedTime?.weekId.toString().slice(0, 4).toString() + "-W" + this.state.selectedTime?.weekId.toString().slice(4)}/>
								{this.state.selectedTime ?
									<label>
										{moment(this.state.selectedTime?.weekId.toString().slice(0, 4) + "W" + this.state.selectedTime?.weekId.toString().slice(4)).format('MMMM DD')}
										-
										{moment(this.state.selectedTime?.weekId.toString().slice(0, 4) + "W" + this.state.selectedTime?.weekId.toString().slice(4)).add(6, 'day').format('MMMM DD')}
										&nbsp;</label> : null}
							</div>
							<br/>
							<div className={'row'}>
								<ButtonGroup size={"md"}>
									{['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day) => {
										return <div style={{display: 'flex', flexDirection: 'row'}}>
											<Button
												id={day}
												onClick={this.handleTempWorkingDays}
												outline={!this.state.tempWorkingDays.includes(day)}
												active={this.state.tempWorkingDays.includes(day)}
												color={"primary"}
											>
												{day}
											</Button>
										</div>
									})}
								</ButtonGroup>
							</div>
						</div>}
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.handleTempTimeSave}>Save</Button>
						<Button color="secondary" onClick={() => {
							this.setState({editModal: false, tempDaysOff: [], selectedTime: null})
						}}>Close</Button>
					</ModalFooter>
				</Modal>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}

export default Framework.Components.withRootState(User);
